export enum TrackName {
  introductionToScratch = 'Introduction To Scratch',
  moreScratch = 'More Scratch',
  furtherScratch = 'Further Scratch',
  introductionToPython = 'Introduction to Python',
  introductionToUnity = 'Introduction to Unity',
}
